import { Box, Text, Divider, Stack } from "@chakra-ui/react"

function InfoTooltipCard({ created_at, updated_at, created_by, updated_by }: {
  created_at?: string,
  updated_at?: string,
  created_by?: string,
  updated_by?: string
}) {
  return (
    <Box p={3} bg="white" color="black" borderRadius="md" minW="220px" boxShadow="lg">
      <Stack spacing={2}>
        <Box>
          <Text fontWeight="bold" fontSize="sm" color="gray.700">Criado por</Text>
          <Text fontSize="sm" color="gray.900">{created_by || '-'}</Text>
          <Text fontWeight="bold" fontSize="sm" color="gray.700" mt={1}>Criado em</Text>
          <Text fontSize="sm" color="gray.900">{created_at || '-'}</Text>
        </Box>
        {(updated_by || updated_at) && <Divider my={1} />}
        {(updated_by || updated_at) && (
          <Box>
            <Text fontWeight="bold" fontSize="sm" color="gray.700">Atualizado por</Text>
            <Text fontSize="sm" color="gray.900">{updated_by || '-'}</Text>
            <Text fontWeight="bold" fontSize="sm" color="gray.700" mt={1}>Atualizado em</Text>
            <Text fontSize="sm" color="gray.900">{updated_at || '-'}</Text>
          </Box>
        )}
      </Stack>
    </Box>
  )
}

export default InfoTooltipCard